export { Layout6040 } from "./Layout6040/Layout6040";
export { Layout5050 } from "./Layout5050/Layout5050";
